import PropTypes from "prop-types";
import { MenuItem, Slider, Stack, TextField, Typography } from "@mui/material";

export const SelectPropertyField = ({ label, value, options, onChange, sx }) => (
  <TextField
    select
    fullWidth
    size="small"
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{ mb: 1.5, ...sx }}
  >
    {options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
);

SelectPropertyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
};

export const SliderPropertyField = ({ label, value, min, max, step = 1, unit = "", onChange, onChangeCommitted }) => (
  <Stack sx={{ mb: 2 }}>
    <Typography variant="caption">
      {label}: {value}
      {unit}
    </Typography>
    <Slider
      size="small"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(_, val) => onChange?.(val)}
      onChangeCommitted={(_, val) => {
        if (onChangeCommitted) {
          onChangeCommitted(val);
        } else {
          onChange?.(val);
        }
      }}
    />
  </Stack>
);

SliderPropertyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  unit: PropTypes.string,
  onChange: PropTypes.func,
  onChangeCommitted: PropTypes.func,
};
 